import { useMutation } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { useCountry } from '../../components/CountrySelector';
import { useOrderSummary, GET_ORDER_SUMMARY_QUERY } from '../useOrderSummary';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';
import {
  ChargeOrderMutation,
  ChargeOrderMutationVariables,
  CHARGE_ORDER_MUTATION
} from './useChargeOrder.rest';

export const useChargeOrder = (orderNumber: string) => {
  const {
    country: { alpha2Code, alpha3Code }
  } = useCountry();

  const { orderSummary } = useOrderSummary(orderNumber);

  const [mutate, { loading, error }] = useMutation<
    ChargeOrderMutation,
    ChargeOrderMutationVariables
  >(CHARGE_ORDER_MUTATION, {
    refetchQueries: [
      {
        query: GET_ORDER_SUMMARY_QUERY,
        variables: {
          countryCode: alpha2Code,
          orderNumber: orderNumber
        }
      }
    ]
  });

  const chargeOrder = useCallback(async () => {
    if (!orderSummary) return;

    await mutate({
      variables: {
        orderId: orderSummary.id,
        input: {
          data: {
            action_type: UpdateOrderAction.Charge,
            id: orderSummary.id,
            type: 'orders',
            attributes: {
              country_code: alpha3Code,
              order_state: OrderState.Charge,
              payment_id: orderSummary.attributes.userPaymentMethodId,
              selected_items_ids: orderSummary.attributes.selectedItemsIds || [],
              use_reward_points: orderSummary.attributes.useRewardPoints,
              use_site_credit: orderSummary.attributes.useSiteCredit
            }
          }
        }
      }
    });
  }, [alpha3Code, mutate, orderSummary]);

  return { chargeOrder, loading, error };
};
